// extracted by mini-css-extract-plugin
module.exports = {"burger":"sidenav__burger__10B70","burgerlines":"sidenav__burgerlines__2mOZI","sidenavContainer":"sidenav__sidenavContainer__3KebA","option":"sidenav__option__1lteC"};